<template>
  <div class="sign-up-basics">

    <header-bar></header-bar>

    <section class="instructions">
      <div class="grid-container">
        <div class="col-4">
          <h2>Tell us a bit more about you, your work and areas of interest.</h2>
        </div>
      </div>
    </section>
    <section class="long-form">
      <div class="grid-container">
        <div class="row">
          <div class="shift-3 col-3">
            <label>First name:</label>
            <input class="" type="text" v-model.trim="firstname" placeholder="John" required />
          </div>
          <div class="col-3">
            <label>Last name:</label>
            <input class="" type="text" v-model.trim="surname" placeholder="Smith" required />
          </div>
        </div>
        <div class="row">
          <div class="shift-3 col-3">
            <label>Where do you work?</label>
            <input class="" type="text" v-model.trim="organisation" placeholder="Example PLC" required />
          </div>
          <div class="col-3">
            <label>Organisation website:</label>
            <input class="" type="url" v-model.trim="website" placeholder="example.com" required />
          </div>
        </div>
        <div class="row">
          <div class="shift-3 col-3">
            <label>Where are you currently based?</label>
            <input type="text" v-model.trim="location" placeholder="London"></input>
          </div>
          <div class="col-3">
            <label>What's your job title?</label>
            <input class="" type="text" v-model.trim="jobtitle" placeholder="Operations Manager" required />
          </div>
        </div>
      </div>
    </section>
    <section class="sign-up-navigation">
    <div class="grid-container">
      <a href="#" v-on:click.stop.prevent="cancel" class="link-back">Cancel</a>
      <a href="#" v-on:click.stop.prevent="save" class="btn btn-big bg-four active">Save</a>
    </div>
    </section>
  </div>
</template>

<script>
import HeaderBar from '@/components/HeaderBar'
import { db } from '@/firebase'
import router from '@/router'
import toTitleCase from 'titlecase'

export default {
  data () {
    return {
      firstname: this.$root.profile.firstname,
      surname: this.$root.profile.surname,
      organisation: this.$root.profile.organisation,
      website: this.$root.profile.website,
      location: this.$root.profile.location,
      jobtitle: this.$root.profile.jobtitle
    }
  },
  components: {
    HeaderBar
  },
  methods: {
    cancel () {
      router.go(window.history.back())
    },
    save () {
      let user = this.$root.user.uid
      let oldSlug = this.$root.profile.slug

      let slug = this.firstname + '-' + this.surname
      let saveSlug = slug.toLowerCase()

      let searchterm = this.firstname + ' ' + this.surname
      let saveSearchTerm = searchterm.toLowerCase()

      // Remove and add new slug
      db.ref('user-meta/slug/' + oldSlug).remove()
      let userSlug = {[saveSlug]: user}
      db.ref('user-meta/slug').update(userSlug)

      db.ref('users/' + user).update({
        firstname: toTitleCase(this.firstname),
        surname: toTitleCase(this.surname),
        organisation: toTitleCase(this.organisation),
        website: this.website,
        jobtitle: toTitleCase(this.jobtitle),
        location: toTitleCase(this.location),
        slug: saveSlug,
        searchterm: saveSearchTerm
      }, function () {
        // On complete
        console.log('saved')
        router.push(saveSlug)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// UserMeta.vue?154f8c3d